<div class="container_dialog">
  <div class="header_popup">
    <div class="title_popup">
      <span>{{"common.add"|translate}} {{data!.type | translate}}</span>
    </div>
    <button class="close_btn" (click)="closed()">
      <img src="assets/icones/close.svg" alt="">
    </button>
  </div>
  <form class="display_form" [formGroup]="form">
    <div class="input_field">
      <label>{{data!.type | translate}}</label>
      <input
        class="input"
        type="text"
        formControlName="name"
        [placeholder]="'Catalogs.marque'|translate"
      />
    </div>
    <div *ngIf="this.data.type === 'category'" class="input_field">
      <label for="">{{"Categories.Parent_category"|translate}}</label>
      <input type="text" [placeholder]="'Categories.categories'|translate" [formControl]="categoryControl" [matAutocomplete]="auto2"
      class="input">
      <mat-autocomplete #auto2="matAutocomplete">
        <mat-option *ngFor="let category of filteredCategories$ | async " [value]="category.name"
          (click)="onCategorySelected(category)">
          {{ category.name }}
        </mat-option>
    </mat-autocomplete>
    </div>
  </form>
  <div class="submet_btns">
    <button class="save_btn_pop_up" *appHasPermission="{ module: 'product', action: 'create' }" (click)="save()" >{{"common.add"|translate}}</button>
  </div>
</div>
